import React from "react";

const Footer = () => {
  return (
    <div className="w-full flex bg-white items-center justify-center z-50 px-6 py-20 flex-col overflow-hidden">
      <p className="font-light uppercase -translate-y-1/4 absolute transform -translate-x-1/2 text-gray-100 left-1/2 whitespace-nowrap hidden md:block" style={{fontSize:"120px"}}>white rabbit</p>
      <div className="items-center flex flex-col sm:flex-row w-full justify-around text-white gap-8 z-10">
        <div className="flex flex-col items-center justify-center">
          <img src="/logo.png" alt="logo" className="w-20" />
          <a className="bg-black text-base px-6 py-2 mt-8 rounded-full font-bold text-white hover:scale-90 duration-100 transform flex items-center gap-2" href="https://bit.ly/31iC9oK" target="_blank" rel="noreferrer">Join Discord
            <img src="/icons/ico_discord_white.svg" alt="discord icon" className="h-6" />
          </a>
        </div>
        <div className="flex flex-col text-black">
          <div className="flex flex-col items-center">
            <span className="font-bold">#followthewhiterabbit</span>
            <span>on socials</span>
          </div>
          <div className="flex justify-around gap-8 items-center mt-6">
            <a href="https://twitter.com/WhiteRabbitGATE" target="_blank" rel="noreferrer">
              <img className="" src="/icons/twitter.svg" alt="social icon" />
            </a>
            <a href="https://www.instagram.com/whiterabbitbygate" target="_blank" rel="noreferrer">
              <img className="" src="/icons/instagram.svg" alt="social icon" />
            </a>
            <a href="https://bit.ly/31iC9oK" target="_blank" rel="noreferrer">
              <img className="" src="/icons/discord.svg" alt="social icon" />
            </a>
          </div>
          <p className="text-center text-xs mt-18">design by AM2 Studio</p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
